export default __webpack_public_path__ + "static/media/just_ok.e76d2237.svg";